(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qp-help-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-qp-help]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      root.querySelectorAll('[data-help-enhancement], [data-help-video]').forEach(el => el.hidden = false);
      const input = root.querySelector('[data-help-search]');
      const items = [...root.querySelectorAll('[data-help-item]')];
      const groups = [...root.querySelectorAll('[data-help-group]')];
      const status = root.querySelector('[data-help-status]');
      const normalize = value => value.normalize('NFKD').toLowerCase().replace(/[^a-z0-9\s-]/g, '');
      const filter = () => {
        const terms = normalize(input.value).trim().split(/\s+/).filter(Boolean);
        let count = 0;
        items.forEach(item => {
          const haystack = normalize(item.textContent + ' ' + item.closest('[data-help-group]').querySelector('h2').textContent);
          const match = terms.every(term => haystack.includes(term));
          item.hidden = !match;
          if (!match) {
            item.querySelectorAll('[data-help-player]').forEach(player => player.replaceChildren());
            item.querySelectorAll('[data-help-video]').forEach(button => button.hidden = false);
          }
          if (match) count++;
        });
        groups.forEach(group => group.hidden = ![...group.querySelectorAll('[data-help-item]')].some(item => !item.hidden));
        root.querySelector('[data-help-empty]').hidden = count > 0;
        status.textContent = terms.length ? `${status.dataset.resultLabel}: ${count}` : '';
      };
      const clear = () => { input.value = ''; filter(); };
      input.addEventListener('input', filter);
      root.querySelector('[data-help-clear]').addEventListener('click', () => { clear(); input.focus(); });
      root.querySelector('[data-help-expand]')?.addEventListener('click', () => items.filter(item => !item.hidden).forEach(item => item.open = true));
      root.querySelector('[data-help-collapse]')?.addEventListener('click', () => items.forEach(item => item.open = false));
      const followHash = () => {
        let id;
        try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const aliases = { military: 'carrier-guides', safety: 'work' };
        const target = document.getElementById(aliases[id] || id);
        if (!target || !root.contains(target)) return;
        clear();
        if (target.matches('[data-help-item]')) target.open = true;
        requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
      };
      root.querySelectorAll('a[href^="#"]').forEach(anchor => anchor.addEventListener('click', () => {
        clear();
        const target = document.getElementById(anchor.hash.slice(1));
        if (target?.matches('[data-help-item]')) target.open = true;
      }));
      window.addEventListener('hashchange', followHash);
      if (location.hash) followHash();
      root.querySelectorAll('[data-help-video]').forEach(button => button.addEventListener('click', () => {
        if (!/^[a-zA-Z0-9_-]{11}$/.test(button.dataset.helpVideo)) return;
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube-nocookie.com/embed/${button.dataset.helpVideo}?autoplay=1&start=${Number(button.dataset.start) || 0}`;
        frame.title = button.dataset.title;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        button.parentElement.querySelector('[data-help-player]').replaceChildren(frame);
        button.hidden = true;
        frame.focus();
      }));
      items.forEach(item => item.addEventListener('toggle', () => {
        if (item.open) return;
        item.querySelectorAll('[data-help-player]').forEach(player => player.replaceChildren());
        item.querySelectorAll('[data-help-video]').forEach(button => button.hidden = false);
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qp-iceplate-360"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qp-iceplate-360')) {
    customElements.define('qp-iceplate-360', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const viewer = this.querySelector('.qp-360-image');
        const load = this.querySelector('[data-load]');
        const previous = this.querySelector('[data-previous]');
        const next = this.querySelector('[data-next]');
        const status = this.querySelector('.qp-360-status');
        const urls = JSON.parse(this.querySelector('[data-frames]').textContent);
        const frames = new Map();
        let current = 0;
        let ready = false;
        let pointer = null;
        this.querySelector('.qp-360-controls').hidden = false;
        const rotate = (step) => {
          if (!ready) return;
          current = (current + step + urls.length) % urls.length;
          viewer.src = urls[current];
        };
        load.addEventListener('click', async () => {
          load.disabled = true;
          status.textContent = this.dataset.loading;
          let cursor = 0;
          let failed = false;
          const worker = async () => {
            while (cursor < urls.length) {
              const index = cursor++;
              if (frames.has(index)) continue;
              await new Promise(resolve => {
                const image = new Image();
                image.onload = () => { frames.set(index, image); resolve(); };
                image.onerror = () => { failed = true; resolve(); };
                image.src = urls[index];
              });
            }
          };
          await Promise.all(Array.from({ length: 4 }, worker));
          if (failed) {
            status.textContent = this.dataset.error;
            load.textContent = this.dataset.retry;
            load.disabled = false;
            return;
          }
          ready = true;
          this.setAttribute('data-ready-state', '');
          status.textContent = this.dataset.ready;
          previous.disabled = false;
          next.disabled = false;
          const moveFocus = document.activeElement === load;
          load.hidden = true;
          if (moveFocus) previous.focus();
        });
        previous.addEventListener('click', () => rotate(-1));
        next.addEventListener('click', () => rotate(1));
        viewer.addEventListener('pointerdown', event => {
          if (!ready || !event.isPrimary || event.button !== 0) return;
          pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, lastX: event.clientX, horizontal: false };
          viewer.setPointerCapture(event.pointerId);
        });
        viewer.addEventListener('pointermove', event => {
          if (!pointer || event.pointerId !== pointer.id) return;
          const dx = event.clientX - pointer.x;
          const dy = event.clientY - pointer.y;
          if (!pointer.horizontal) {
            if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
            if (Math.abs(dy) >= Math.abs(dx)) { pointer = null; return; }
            pointer.horizontal = true;
          }
          const steps = Math.trunc((event.clientX - pointer.lastX) / 6);
          if (steps) { rotate(steps % urls.length); pointer.lastX += steps * 6; }
        });
        const stop = () => { pointer = null; };
        viewer.addEventListener('pointerup', stop);
        viewer.addEventListener('pointercancel', stop);
        viewer.addEventListener('lostpointercapture', stop);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qp-inline-faq-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qp-inline-faq-video')) {
  customElements.define('qp-inline-faq-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.trigger = this.querySelector('[data-video-open]');
      this.panel = this.querySelector('[data-video-expanded]');
      this.player = this.querySelector('[data-video-player]');
      this.closeButton = this.querySelector('[data-video-close]');
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => this.openVideo());
      this.closeButton.addEventListener('click', () => this.closeVideo(true));
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) { event.preventDefault(); this.closeVideo(true); }
      });
      this.onToggle = event => { if (!event.target.open) this.closeVideo(false); };
      this.ancestors = [];
      for (let parent = this.parentElement; parent; parent = parent.parentElement) {
        if (parent.tagName === 'DETAILS') { this.ancestors.push(parent); parent.addEventListener('toggle', this.onToggle); }
      }
    }
    disconnectedCallback() {
      this.player?.replaceChildren();
      this.ancestors?.forEach(parent => parent.removeEventListener('toggle', this.onToggle));
    }
    openVideo() {
      document.querySelectorAll('qp-inline-faq-video').forEach(video => { if (video !== this) video.closeVideo?.(false); });
      const frame = document.createElement('iframe');
      const start = Math.max(0, Number.parseInt(this.dataset.start, 10) || 0);
      frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(this.dataset.videoId) + '?autoplay=1&playsinline=1&rel=0&start=' + start;
      frame.title = this.dataset.title;
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      this.player.replaceChildren(frame);
      this.trigger.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
      this.closeButton.focus({preventScroll:true});
    }
    closeVideo(restoreFocus) {
      this.player?.replaceChildren();
      if (!this.panel) return;
      this.panel.hidden = true;
      this.trigger.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) this.trigger.focus({preventScroll:true});
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qp-mobile-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('.flask-layout').forEach(root => {
      if (root.dataset.mobileOrderReady) return;
      const grid = root.querySelector('.grid--product-main-content');
      const media = grid?.querySelector(':scope > .media-area');
      const column = grid?.querySelector(':scope > .content-column');
      const price = column?.querySelector('.block--price');
      if (!media || !price) return;
      root.dataset.mobileOrderReady = 'true';
      const home = document.createComment('');
      media.before(home);
      const video = media.querySelector('qp-video-access');
      const videoHome = document.createComment('');
      video?.before(videoHome);
      const breakpoint = matchMedia('(max-width:767px)');
      const move = () => {
        const inline = media.querySelector('flask-inline-media');
        const thumbnails = inline?.querySelector('.flask-thumbnails');
        if (breakpoint.matches) {
          if (media.parentElement !== column) price.after(media);
          if (video && thumbnails && video.parentElement !== thumbnails) thumbnails.prepend(video);
        } else {
          if (media.parentElement !== grid) home.after(media);
          if (video && video.parentElement !== videoHome.parentElement) videoHome.after(video);
        }
      };
      customElements.whenDefined('qp-video-access').then(move);
      breakpoint.addEventListener('change', move);
      move();
      const sticky = document.querySelector('.builder-sticky');
      if (sticky) {
        const resize = () => document.documentElement.style.setProperty('--qp-cart-clearance', Math.ceil(sticky.getBoundingClientRect().height + 16) + 'px');
        new ResizeObserver(resize).observe(sticky);
        resize();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
